export enum HeaderNavigation {
    ALWAYS = "ALWAYS",
    ANONYMOUS = "ANONYMOUS",
    AUTHENTICATED = "AUTHENTICATED",
    NEVER = "NEVER",
}
